@if (view$ | async; as meters) {
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            {{ 'common_SELECT_METERS' | translate }}
        </h4>
        <div class="d-inline-block" style="margin-left: auto">
            <div ngbDropdown container="body" class="d-inline-block" placement="bottom-right">
                <button type="button" class="btn btn-primary mb-3" id="viewForm" ngbDropdownToggle>
                    {{ 'utilities_VIEW' | translate }}
                </button>
                <div ngbDropdownMenu aria-labelledby="viewForm">
                    <form class="px-4 py-3" novalidate [formGroup]="selectedColumnsForm">
                        <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            style="margin-bottom: 5px"
                            (click)="resetColumns()">
                            {{ 'utilities_standard-view' | translate }}
                        </button>
                        @for (head of columnHeads; track head.column) {
                            @if (!['select', 'meterNo'].includes(head.column)) {
                                <app-checkbox-group
                                    [formControl]="head.displayControl"
                                    [label]="head.label"></app-checkbox-group>
                            }
                        }
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-body">
        <div class="table-responsive">
            <table class="table table-striped table-sm" [formGroup]="meters">
                <thead>
                    <tr>
                        @for (
                            head of columnHeads;
                            track head.column;
                            let i = $index;
                            let first = $first
                        ) {
                            @if (head.displayControl.value) {
                                <th [ngClass]="{'first-column': first}">
                                    <div class="d-flex align-items-center">
                                        @if (first) {
                                            <input
                                                type="checkbox"
                                                class="form-check-input m-0 me-2"
                                                [formControl]="selectAll"
                                                (change)="toggleSelectAll(meters)" />
                                        }
                                        <div
                                            app-sortable-table-header
                                            [column]="head.column"
                                            (sort)="onSort($event)"
                                            [label]="head.label"></div>
                                    </div>
                                </th>
                            }
                        }
                    </tr>
                    <tr [formGroup]="filterForm">
                        @for (
                            head of columnHeads;
                            track head.column;
                            let i = $index;
                            let first = $first
                        ) {
                            @if (head.displayControl.value) {
                                <th class="align-top" [ngClass]="{'first-column': first}">
                                    @switch (head.formType) {
                                        @case ('text') {
                                            <app-input-text-group
                                                [formControl]="
                                                    head.formControl
                                                "></app-input-text-group>
                                        }
                                        @case ('selectMultiple') {
                                            <app-input-dropdown-checkboxes
                                                [formControl]="
                                                    head.formControl
                                                "></app-input-dropdown-checkboxes>
                                        }
                                        @case ('date') {
                                            <app-input-date-group
                                                [formControl]="
                                                    head.formControl
                                                "></app-input-date-group>
                                        }
                                        @case ('boolean') {
                                            <app-checkbox-group
                                                [formControl]="
                                                    head.formControl
                                                "></app-checkbox-group>
                                        }
                                    }
                                </th>
                            }
                        }
                    </tr>
                </thead>
                <tbody formArrayName="meterFormArray">
                    @for (
                        meterFormGroup of meters.controls.meterFormArray.controls
                            | slice: (page - 1) * pageSize : page * pageSize;
                        track $index
                    ) {
                        <tr
                            [formGroupName]="$index"
                            [ngClass]="{
                                red: meterFormGroup.getRawValue().usageAndUnit !== usageAndUnit,
                            }">
                            @for (head of columnHeads; track head.column) {
                                @if (head.displayControl.value) {
                                    <td
                                        [ngClass]="{
                                            'first-column': head.column === 'select',
                                            red:
                                                meterFormGroup.getRawValue().replacedBy != null ||
                                                meterFormGroup.getRawValue().meterCriteriaMismatch,
                                        }">
                                        @if (head.column === 'select') {
                                            <div class="d-flex align-items-center">
                                                <app-checkbox-group
                                                    (change)="checkToggleSelectAll(meters)"
                                                    [id]="meterFormGroup.getRawValue().meterId"
                                                    [formControl]="
                                                        meterFormGroup.controls.select
                                                    "></app-checkbox-group>

                                                @if (
                                                    meterFormGroup.getRawValue().replacedBy != null
                                                ) {
                                                    <div
                                                        class="m-0 me-2 text-warning"
                                                        style="cursor: pointer; z-index: 21">
                                                        <i
                                                            class="bi bi-exclamation-circle-fill"
                                                            popoverClass="custom-popover"
                                                            container="body"
                                                            [ngbPopover]="
                                                                (
                                                                    'monitoring_Replaced-by'
                                                                    | translate
                                                                ).replace(
                                                                    '{0}',
                                                                    meterFormGroup.getRawValue()
                                                                        .replacedBy ?? ''
                                                                )
                                                            "></i>
                                                    </div>
                                                }
                                                @if (
                                                    meterFormGroup.getRawValue()
                                                        .meterCriteriaMismatch === true
                                                ) {
                                                    <div
                                                        class="m-0 text-danger"
                                                        style="cursor: pointer; z-index: 21">
                                                        <i
                                                            class="bi bi-exclamation-circle-fill"
                                                            popoverClass="custom-popover"
                                                            container="body"
                                                            [ngbPopover]="
                                                                'variable-alarms_unsupportedMeter'
                                                                    | translate
                                                            "></i>
                                                    </div>
                                                }
                                            </div>
                                        } @else {
                                            @switch (head.formType) {
                                                @case ('text') {
                                                    {{ meterFormGroup.get(head.column)?.value }}
                                                }
                                                @case ('selectMultiple') {
                                                    {{ meterFormGroup.get(head.column)?.value }}
                                                }
                                                @case ('date') {
                                                    {{
                                                        meterFormGroup.get(head.column)?.value
                                                            | appdate
                                                    }}
                                                }
                                                @default {
                                                    {{ meterFormGroup.get(head.column)?.value }}
                                                }
                                            }
                                        }
                                    </td>
                                }
                            }
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="13">{{ 'common_No-data-available' | translate }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <app-control-messages [control]="meters.controls.meterFormArray"></app-control-messages>
    </div>

    <div class="overflow-auto">
        <app-pagination
            [collectionSize]="meters.controls.meterFormArray.controls.length"
            [page]="page"
            (pageChange)="setPage($event)"
            [(pageSize)]="pageSize"></app-pagination>
    </div>

    <div class="modal-footer text-end button-group">
        <button type="button" class="btn btn-outline-primary" (click)="activeModal.dismiss()">
            {{ 'reporting_CLOSE' | translate }}
        </button>
        <button
            type="button"
            class="btn btn-primary"
            (click)="submit(meters.controls.meterFormArray)">
            {{ 'actions_submit' | translate: 'online' : 'common' }}
        </button>
    </div>
}
